<template>
  <div class="outBox">
    <!-- <el-button @click="handleSort">{{ sort === 'down'? '切到正序':'切到降序'}}</el-button> -->
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.2)" class="mine"></div>
      <div id="main24" class="chart-container"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";



export default {
  name: "echartsone",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
      barData: {},
      sort: 'down', // 正序/降序
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    data: {
      deep: true,
      handler(newYearData, oldYearData) {
        // 时间数据
        const timelist = []
        // 退款数
        const refundAmountlist = []
        // 退款率
        const refundRatelist = []
        newYearData.forEach(e => {
          if (e.time.length > 0) {
            // 在这里合并需要集合的数据
            timelist.unshift(this.generateTimeRange(e.time))
            refundAmountlist.unshift(e.data.refund_Amount)
            refundRatelist.unshift(e.data.refund_Rate)
          }
        });
        this.barData.yData = timelist
        this.barData.xData = refundAmountlist
        this.barData.lineData = refundRatelist.map(value => Number(value * 100).toFixed(2))
        this.initBar();
      },
    }
  },
  methods: {
    // 处理时间格式
    generateTimeRange(array) {
      const startDate = array[0];
      const endDate = array[1];

      const start = new Date(startDate);
      const end = new Date(endDate);

      const formattedStartDate = `${start.getFullYear()}.${start.getMonth() + 1}.${start.getDate()}`;
      const formattedEndDate = `${end.getFullYear()}.${end.getMonth() + 1}.${end.getDate()}`;

      return `${formattedStartDate}-${formattedEndDate}`;
    },
    handleSort() {
      // 切换降序或者降序
      this.sort = this.sort === 'down' ? 'up' : 'down'
      this.barData = {
        yData: this.barData.yData.reverse(),
        xData: this.barData.xData.reverse(),
      }
      this.initBar()
    },
    getData() {
      // 通过异步请求，获取数据
      this.barData = {
        yData: [],
        xData: [],
        otherData: [155, 140, 136, 130, 130],
        lineData: []
      }
    },
    initBar() {
      const _this = this;
      let option = {
        title: {
          text: '退款数&退款率',
          textStyle: {
            color: '#fff' // 设置标题文本颜色为红色
          }
        },
        tooltip: {},
        legend: {
          data: ['退款率'],
          textStyle: {
            color: '#fff' // 设置标题文本颜色为红色
          }
        },
        yAxis: [
          {
            name: '单位（个）', // 添加单位，这里将单位替换为你想要的实际单位
            nameTextStyle: {
              color: '#fff' // 设置单位文本颜色为白色
            },
            axisLine: {
              show: false // Y 轴的轴线是否显示
            },
            axisTick: {
              show: false  // Y 轴的刻度线（tick）是否显示
            },
            // splitLine: { // 添加splitLine属性并设置为不显示
            //   show: false
            // },
            axisLabel: {
              color: '#fff',// 控制 Y 轴标签的颜色
              formatter: function (value) {
                return value; // 将数值除以10000并加上'万'作为单位
              }
              // formatter: '{value} 单位' // 添加单位，这里将单位替换为你想要的实际单位
            }
          },
          // 在yAxis数组中添加一个对象，代表要添加的Y轴
          {
            name: '单位（ % ）', // 添加单位，这里将单位替换为你想要的实际单位
            nameTextStyle: {
              color: '#fff' // 设置单位文本颜色为白色
            },
            axisLine: {
              show: true, // Y 轴的轴线是否显示
              lineStyle: {
                color: "#fff" // Y轴颜色
              }
            },
            // axisLine: {
            //   show: false // Y 轴的轴线是否显示
            // },
            axisTick: {
              show: false  // Y 轴的刻度线（tick）是否显示
            },
            axisLabel: {
              color: '#fff',// 控制 Y 轴标签的颜色
              formatter: function (value) {
                return (value * 100).toFixed(2); // 将数值乘以100并保留两位小数
              }
              // formatter: '{value} 单位' // 添加单位，这里将单位替换为你想要的实际单位
            },
            splitLine: { // 添加splitLine属性并设置为不显示
              show: false
            }
          },
        ],
        xAxis: [
          {
            // 左轴
            // name: '单位(月)',
            // nameLocation: 'end', // 将单位放在轴的末尾（右边）
            nameTextStyle: {
              color: '#fff' // 设置单位文本颜色为白色
            },
            // type: 'category',
            inverse: true,
            axisLabel: {
              inside: false, // X轴名字是否显示在柱状图里面
              zlevel: 2,
              color: '#fff', // X轴名字颜色
              rotate: -15,
              margin: 25, // 上下偏移
              padding: [25, 0, 0, -45] // 根据需要调整右偏移的像素值
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: this.barData.yData // y轴代表的维度  
          }

        ],
        series: [
          {
            name: '退款数',
            zlevel: -1, // 层级
            type: 'bar',
            barWidth: 30, // 内柱条的宽度
            // animationDuration: 1500, // 内柱条的动画显示时间
            showBackground: true,
            // 内柱条样式
            itemStyle: {
              borderRadius: [10, 10, 5, 5], // 左上角和右上角的圆角半径为10
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' }
                ])
              }
            },
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.barData.xData, // x轴代表的数据
            align: 'center',
            tooltip: { // 悬浮代表的提示初始化
            },

          },
          {
            name: '退款率',
            yAxisIndex: 1, // 将这个系列数据绑定到右侧的Y轴上
            type: 'line',
            smooth: true, // 平滑曲线
            data: this.barData.lineData,
            itemStyle: {
              color: '#ffc107',
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              shadowBlur: 10,
              borderWidth: 2,
              borderColor: new echarts.graphic.RadialGradient(
                0.4,
                0.3,
                1,
                [
                  { offset: 0, color: 'rgba(255, 215, 0, 0.8)' },
                  { offset: 1, color: 'rgba(255, 255, 255, 0)' },
                ],
                false
              ),
            },
            lineStyle: {
              color: '#ffc107', // 设置折线的颜色为黄色
              width: 2, // 设置折线的粗细
              shadowColor: 'rgba(0, 0, 0, 0.3)', // 设置阴影颜色
              shadowBlur: 5, // 设置阴影模糊度
            },
            emphasis: { // 设置高亮效果
              lineStyle: {
                width: 4, // 设置高亮时折线的粗细
                shadowColor: 'rgba(0, 0, 0, 0.5)', // 设置高亮时折线的阴影颜色
                shadowBlur: 10, // 设置高亮时折线的阴影模糊度
              }
            },
            symbol: 'circle', // 标记的图形为实心圆形
            symbolSize: 8,
          }
        ],


      };
      // 使用刚指定的配置项和数据显示图表。
      if (this.chart) {
        this.chart.setOption(option);
      }
      // 隐藏加载效果
      setTimeout(() => {
        this.loading = false;
      }, 2000)
    },
    async initData() {
      this.loading = true;
      await this.getData();

      // 基于准备好的dom，初始化echarts实例
      this.chart = echarts && echarts.init(document.getElementById('main24'));
      // 指定图表的配置项和数据
      this.initBar();
    }
  },
  beforeDestroy() {
    this.chart.clear();
  }
}
</script>

<style scoped>
.outBox {
  width: 550px;
  height: 300px;
  padding: 5px;
  border-radius: 3%;
  border: 2px solid #6c8fcd;
  box-shadow: 1px 1px 5px 1px #6c8fcd;
}

.box {
  width: 550px;
  height: 300px;
  /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%;
  /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%;
  /* 与组件中的高度一致 */
}
</style>